import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16.01 16.81",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.01 16.81\" id=\"icon-search\"><path d=\"M9.41 0a6.61 6.61 0 0 0-6.6 6.6 6.51 6.51 0 0 0 1.65 4.34L0 15.4l1.41 1.41L6 12.23a6.43 6.43 0 0 0 3.42 1A6.615 6.615 0 1 0 9.41 0zm0 11.2A4.6 4.6 0 1 1 14 6.6a4.6 4.6 0 0 1-4.59 4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol